import React from "react";

function LoginText(props){
    return (
        <h2 className="login text-center ctext-primary SFPDBold">{props.text}</h2>
    )
}

export default LoginText;